module.exports = __webpack_public_path__ + "img/edit-button.99fbb107.svg";